import { ESiteConstraint } from "~domain/sites/models/site-constraint-model.ts";

const constraints: Record<ESiteConstraint, string> = {
  [ESiteConstraint.HAS_DEFINITIVE_DEACTIVATION]: "Désactivation définitive",
  [ESiteConstraint.HAS_TEMPORARY_DEACTIVATION]: "Désactivation temporaire",
  [ESiteConstraint.HAS_LINK_DEACTIVATION]: "Désactivation par voies links",
  [ESiteConstraint.HAS_PLANNING]: "Planning",
  [ESiteConstraint.HAS_MODULATION_LIMITATION]: "Aménagement des modulations",
};

export const SITE_CONSTRAINTS_CARD_FRENCH_LOCALE = {
  title: "Contraintes de production",
  noConstraint: "Aucune contrainte",
  constraints,
};
